import type {
	SeriesMarkerPosition,
	SeriesMarkerShape,
	Time,
} from "lightweight-charts";
import type { LibraryChartState } from "./ui/AdvancedChart/types";

export interface IMarker {
	time: Time;
	position: SeriesMarkerPosition;
	color: string;
	text: string;
	shape: SeriesMarkerShape;
	size: number;
}

export type ChartState = Partial<LibraryChartState> & {
	ticker?: string;
	color?: string;
	timeFrame?: Timeframes;
	type?: ChartTypes;
	panels?: Subcharts[];
	datasets?: Datasets[];
	applyPanels?: string[];
	applyDatasets?: string[];
	isPanelOpen?: boolean;
	isPartOfWidget?: boolean;
	showFullRange?: boolean;
	openIndicatorsDialog?: boolean;
};

export enum ChartTypes {
	LIGHT = "Light",
	ADVANCED = "Adv.",
}

export enum Timeframes {
	ONE_MIN = "1 min",
	FIVE_MIN = "5 min",
	FIFTEEN_MIN = "15 min",
	ONE_HOUR = "1 hour",
	ONE_DAY = "Day",
	ONE_WEEK = "Week",
}

export enum Subcharts {
	TimingMomentum = "Timing Momentum",
	Powerdays = "Powerdays",
	PwdTrend = "Powerdays Trend",
	RMRComp = "RMR Rel. Market Rank",
	RMRMonthly = "RMR 1M-1Y",
	RMRSlope = "RMR Slope",
	PriceMomSlope = "Price Momentum Slope",
	InxRatTrendSlope = "Index Ratio Trend Slope",
	SectInxRatTrend = "Sector and Index Ratio Trend",
	VolStrength = "Volatility Strength",
}

export enum Datasets {
	PETTM = "PE TTM",
	PEFTM = "PE FTM",
	EPS = "EPS",
	Sales = "Sales",
	ProfMargin = "Prof Margin",
	FreeCFlow = "Free cash flow",
	EVEb = "EV/Ebitda",
	RSEZ = "EPS RS (Z)",
	RSSZ = "Sales RS (Z)",
	RSEF = "EPS RS (F)",
	RSSF = "Sales RS (F)",
	ShortInt = "Short Int %",
	DarkShort = "Dark Short",
	DarkShortSlope = "Dark Short Slope",
}
